import functions from "./functions.js";
const recaptcaPublicKey = '6LezCDEmAAAAANYbS5PYiXnzuhWgmg-HmEYWim2b';
$(function () {

    const $form = $('.form-contact');
    const form = $form[0];

    const lang = functions.getLang();
    let output = '';

    if (!form) return;
    
    $form.on('submit', e => {
        e.preventDefault();

        $form.find('.contact-btn').addClass('d-none');
        $form.find('.contact-spinner').removeClass('d-none');
        $form.find('.contact-spinner').addClass('d-flex');

        let params = {};
        $.each($form.serializeArray(), function (i, field) {
            params[field.name] = field.value;
        });

        params['language'] = functions.getLang();

        //$output.html('').addClass('d-none');
        grecaptcha.ready(function () {
            grecaptcha.execute(recaptcaPublicKey, { action: 'contact' }).then(function (token) {
                params['gRecaptchaToken'] = token;
                params = functions.getDataForUrl(params);
                $.post('/services/contact/', params).then(response => {
                    
                    $('#contact-modal').modal('show');
                    $(".response-output").html(response.data);

                    $form.find('.contact-btn').removeClass('d-none');
                    $form.find('.contact-spinner').removeClass('d-flex');
                    $form.find('.contact-spinner').addClass('d-none');

                    // setTimeout(() => { $('#contact-modal').modal('hide') }, 4000);

                    if (response.status == true) {
                        form.reset();
                    }
                });
            });
        });

    });

});